// R3.A — Churn Cohort report. Data from GET /v1/bo/churn/cohort
// (see backoffice.routes.js -> models.churn.getCohortReport).
// Read-only: numbers are computed by bot_churn.js / POST /v1/bo/churn/recompute,
// not editable here.
let churnCohortSection = {
  name: "Churn per Cohort",
  slug: "churnCohort",
  visible: true,
  singularName: "churnCohort",
  crud: true,
  endpoint: "/v1/bo/churn/cohort",
  updateLabel: "churnCohort",
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  noNeedSearch: true,
  noNeedRefresh: false,
  add: false,
  update: false,
  edit: false,
  exportToCsv: true,
  fields: [
    {
      label: "Cohort",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.cohort_label ? row.cohort_label : "-"),
    },
    {
      label: "Tipe",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.cohort_type === "annual" ? "Tahunan" : "Bulanan"),
    },
    {
      label: "Members Expiring",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.members_expiring != null ? row.members_expiring : "-"),
    },
    {
      label: "Renewed",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.members_renewed != null ? row.members_renewed : "-"),
    },
    {
      label: "Churned",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.members_churned != null ? row.members_churned : "-"),
    },
    {
      label: "Churn Rate",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.churn_rate != null ? `${row.churn_rate}%` : "-"),
    },
    {
      label: "Renewal Rate",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.renewal_rate != null ? `${row.renewal_rate}%` : "-"),
    },
    {
      label: "Dihitung",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.computed_at ? row.computed_at : "-"),
    },
  ],
};

export default [churnCohortSection];
